var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtBoard7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 170,
    viewBox: "0 0 183 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.1513 63.8828C71.3931 63.8288 70.6428 64.0569 70.0634 64.5177C67.379 67.0363 72.8075 77.7734 84.1045 88.3151C89.5256 93.3872 95.2896 97.5174 100.315 99.9383C104.722 102.031 108.257 102.638 109.539 101.445C112.224 98.9267 106.795 88.1896 95.5059 77.6478C86.1253 68.8641 76.6403 63.8828 72.1513 63.8828Z",
    fill: "#C7C7C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2948 67.1484L45.7027 122.181C45.482 122.747 45.446 123.36 45.5992 123.945C45.7524 124.529 46.088 125.06 46.565 125.472C47.042 125.884 47.6394 126.159 48.2841 126.263C48.9288 126.367 49.5925 126.296 50.1939 126.059L107.485 103.273C105.363 103.117 102.815 102.326 99.8292 100.905C94.5074 98.3757 88.4457 94.1256 82.7389 88.8582C75.0974 81.8051 68.4978 73.1383 67.2948 67.1484Z",
    fill: "#043A66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7754 109.524L99.5694 106.43C91.1711 104.296 83.3359 100.609 76.5445 95.5937C70.8096 91.5039 65.8483 86.5731 61.8605 81L59.5273 86.954C61.583 89.4941 63.8395 91.8915 66.2788 94.1269C68.4261 96.1008 70.7001 97.9548 73.0886 99.6791C78.7475 103.799 85.0463 107.118 91.7754 109.524Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2026 116.112L81.9322 113.433C76.9592 111.336 72.2768 108.701 67.9845 105.584C63.6678 102.493 59.773 98.9359 56.3846 94.9883L54.1973 100.634C55.3201 101.826 56.5012 102.998 57.748 104.137C59.8887 106.103 62.1553 107.951 64.5359 109.669C67.8873 112.089 71.4556 114.244 75.2026 116.112Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7899 122.241L65.9653 119.77C63.6949 118.481 61.5042 117.077 59.4034 115.564C56.4196 113.408 53.6302 111.034 51.0626 108.465L48.9336 113.883L49.1377 114.077C51.2801 116.042 53.5467 117.889 55.9256 119.609C57.204 120.543 58.4921 121.42 59.7899 122.241Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.035 90.177C162.38 90.177 163.47 89.1755 163.47 87.9401C163.47 86.7046 162.38 85.7031 161.035 85.7031C159.69 85.7031 158.6 86.7046 158.6 87.9401C158.6 89.1755 159.69 90.177 161.035 90.177Z",
    fill: "#F5F5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2689 75.3984C31.4045 75.3984 32.325 74.5528 32.325 73.5098C32.325 72.4667 31.4045 71.6211 30.2689 71.6211C29.1334 71.6211 28.2129 72.4667 28.2129 73.5098C28.2129 74.5528 29.1334 75.3984 30.2689 75.3984Z",
    fill: "#F5F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.755 76.8047C106.891 76.8047 107.811 75.9591 107.811 74.916C107.811 73.8729 106.891 73.0273 105.755 73.0273C104.62 73.0273 103.699 73.8729 103.699 74.916C103.699 75.9591 104.62 76.8047 105.755 76.8047Z",
    fill: "#F5F5F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4564 113.422C27.592 113.422 28.5125 112.576 28.5125 111.533C28.5125 110.49 27.592 109.645 26.4564 109.645C25.3209 109.645 24.4004 110.49 24.4004 111.533C24.4004 112.576 25.3209 113.422 26.4564 113.422Z",
    fill: "#F5F5F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M123.994 113.5C125.129 113.5 126.05 112.654 126.05 111.611C126.05 110.568 125.129 109.723 123.994 109.723C122.858 109.723 121.938 110.568 121.938 111.611C121.938 112.654 122.858 113.5 123.994 113.5Z",
    fill: "#F5F5F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2807 46.5273C47.4162 46.5273 48.3367 45.6818 48.3367 44.6387C48.3367 43.5956 47.4162 42.75 46.2807 42.75C45.1451 42.75 44.2246 43.5956 44.2246 44.6387C44.2246 45.6818 45.1451 46.5273 46.2807 46.5273Z",
    fill: "#F5F5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9544 56.3912C76.9177 51.383 76.4315 46.6153 76.0003 43.792L82.7871 42.7487C83.2508 45.785 82.7485 51.0891 82.787 56.3551C82.8252 61.5594 81.1903 67.1908 79.6492 71.5475L75.3216 70.0028C76.5627 66.4942 76.9915 61.461 76.9544 56.3912Z",
    fill: "#043A66"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.124 87.8718C114.072 81.527 127.986 80.9439 144.029 83.5637L141.259 77.2426C124.492 74.5045 112.899 76.029 98.3785 83.1444L101.124 87.8718Z",
    fill: "#043A66"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.012 68.8682C98.7711 63.1334 102.995 55.2916 104.74 49.9506L112.289 51.9553C110.331 57.9491 103.749 66.0784 97.2993 72.5011L93.012 68.8682Z",
    fill: "#F5F5F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.332 101.082C126.787 100.334 136.141 101.983 141.827 103.935L144.031 97.4717C137.65 95.2815 127.481 96.1869 118.012 97.0242L118.332 101.082Z",
    fill: "#F5F5F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.609 37.0162C101.849 37.0162 102.855 36.0927 102.855 34.9534C102.855 33.8142 101.849 32.8906 100.609 32.8906C99.3687 32.8906 98.3633 33.8142 98.3633 34.9534C98.3633 36.0927 99.3687 37.0162 100.609 37.0162Z",
    fill: "#F5F5F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9702 126.446C78.2105 126.446 79.2159 125.522 79.2159 124.383C79.2159 123.244 78.2105 122.32 76.9702 122.32C75.73 122.32 74.7246 123.244 74.7246 124.383C74.7246 125.522 75.73 126.446 76.9702 126.446Z",
    fill: "#F5F5F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6243 25.5144L43.9578 20.9219L42.2913 25.5144L38.125 26.9495L42.2913 28.3847L43.9578 32.9772L45.6243 28.3847L49.7906 26.9495L45.6243 25.5144Z",
    fill: "#043A66",
    stroke: "#043A66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M154.661 131.139L152.995 126.547L151.328 131.139L147.162 132.575L151.328 134.01L152.995 138.602L154.661 134.01L158.828 132.575L154.661 131.139Z",
    fill: "#043A66",
    stroke: "#043A66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M138.611 96.1318L137.63 93.4492L136.65 96.1318L134.199 96.9701L136.65 97.8083L137.63 100.491L138.611 97.8083L141.062 96.9701L138.611 96.1318Z",
    fill: "#846AB5",
    stroke: "#846AB5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M128.699 67.9677L127.718 65.2852L126.738 67.9677L124.287 68.806L126.738 69.6443L127.718 72.3268L128.699 69.6443L131.15 68.806L128.699 67.9677Z",
    fill: "#FA465F",
    stroke: "#FA465F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6245 58.8114L92.6441 56.1289L91.6638 58.8114L89.2129 59.6497L91.6638 60.488L92.6441 63.1706L93.6245 60.488L96.0754 59.6497L93.6245 58.8114Z",
    fill: "#5891CB",
    stroke: "#5891CB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5249 81.3466L86.5445 78.6641L85.5642 81.3466L83.1133 82.1849L85.5642 83.0232L86.5445 85.7057L87.5249 83.0232L89.9758 82.1849L87.5249 81.3466Z",
    fill: "#E6DB2F",
    stroke: "#E6DB2F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2749 41.206L71.2945 38.5234L70.3142 41.206L67.8633 42.0443L70.3142 42.8826L71.2945 45.5651L72.2749 42.8826L74.7258 42.0443L72.2749 41.206Z",
    fill: "#3DC0B1",
    stroke: "#3DC0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M140.175 27.6277L138.509 23.0352L136.842 27.6277L132.676 29.0628L136.842 30.498L138.509 35.0905L140.175 30.498L144.341 29.0628L140.175 27.6277Z",
    fill: "#043A66",
    stroke: "#043A66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0088 96.1645L17.157 91.3359L15.3052 96.1645L10.6758 97.6734L15.3052 99.1824L17.157 104.011L19.0088 99.1824L23.6383 97.6734L19.0088 96.1645Z",
    fill: "#043A66",
    stroke: "#043A66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtBoard7);
export default __webpack_public_path__ + "static/media/ArtBoard7.bc05b31b0a631a4a2c37a9cbf412a7b8.svg";
export { ForwardRef as ReactComponent };